import { ClassificationType, type ClassificationPagination, type ClassificationBasicItem } from '@/types/classification';

interface ExtendClassificationPagination extends ClassificationPagination {
    query: string;
    source: string;
    status: number;
}

interface ExtendClassificationBasicItem extends ClassificationBasicItem {
    children: ClassificationBasicItem[];
}

export interface ApiClassificationHelperSearchRequest {
    q: string;
    type: ClassificationType;
    start: number;
}

export interface ApiClassificationHelperSearchResponse {
    response: {
        h_words: string[];
        query_results: {
            cls_tree: ExtendClassificationBasicItem;
        }[];
    };
    responseHeader: ExtendClassificationPagination;
}

export const ClassificationHelperSearch = Symbol.for('ClassificationHelperSearch');

export interface ClassificationHelperSearch {
    classificationHelperSearch(data: ApiClassificationHelperSearchRequest): Promise<ApiClassificationHelperSearchResponse>;
}
